export function getAppInstanceId(userAgent: string) {
  const regex = /app_instance_id\/(\d+)/i;
  const match = userAgent.match(regex);

  const instance = match?.[1];
  if (instance) {
    return Number.isNaN(Number(instance)) ? 0 : Number(instance);
  }
  return 0;
}
